/**
 * @generated SignedSource<<9671727f0097dfde00a6ef670d1d5bf7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetailsPromise_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerIncentives_user">;
  readonly " $fragmentType": "PdpRespSidebarDetailsPromise_user";
};
export type PdpRespSidebarDetailsPromise_user$key = {
  readonly " $data"?: PdpRespSidebarDetailsPromise_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsPromise_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetailsPromise_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerIncentives_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4a8a6761b12a6fc1dbacbdddcdd53ecb";

export default node;
